<template>
  <div class="home-audit">
    <div class="audit">
      <div v-if="type==1" class="audit-div">
        <img src="../../assets/image/Underreview.png" alt />
        <p>商家审核需要3~5个工作日，请等待</p>
        <p class="audit-centre" @click="centers">返回推广中心 ></p>
      </div>
      <div v-if="type==2" class="audit-audit">
        <img src="../../assets/image/Auditfailed.png" alt />
        <p>申请已驳回</p>
        <p>驳回理由：{{name}}</p>
      </div>
    </div>

    <div class="home-audit-button" v-if="type==2">
      <div class="home-button">
        <p>
          联系客服：{{pohop}}
          <img src="../../assets/image/lALPG.png" alt />
        </p>
        <Debounce :time="2000" isDebounce>
          <van-button type="info" size="large" @click="anew" round>重新提交</van-button>
        </Debounce>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/utils/https";
import { Toast } from "vant";
import { getUserToken } from "@/utils/Cookie";
export default {
  name: "audit",

  data() {
    return {
      type: "2",
      name: "",
      pohop: "0830－2636353"
    };
  },
  methods: {
    centers() {
      this.$router.push({
        path: "promotion"
      });
    },
    async requsetr() {
      let res = await request(
        "user/business/merchantApplyStatus?token=" + getUserToken()
      );
      if (res.error == 0 && res.data) {
        if (res.data.status == 2) {
          this.type = 2;
          this.name = res.data.status_desc;
        } else {
          this.type = 1;
        }
      } else {
        Toast(res.error_reason);
      }
    },
    async anew() {
      let res = await request(
        "user/business/deleteApplyInfo?token=" + getUserToken()
      );
      if (res.error == 0) {
        this.$router.push({
          path: "merchant"
        });
      }
    }
  },
  mounted() {
    this.requsetr();
  }
};
</script>
<style lang="scss" scoped>
.audit-centre {
  color: #0065f0 !important;
}
.home-audit {
  width: 100%;
  height: 100%;

  // position: absolute;
  // padding: 0 0.9375rem 2.5rem 0.9375rem;

  .home-audit-button {
    width: 100%;
    // height: 5.6875rem;
    position: absolute;
    bottom: 0;
    .home-button {
      height: 5.6875rem;
      padding: 0 0.9375rem 2.5rem 0.9375rem;
      text-align: center;
      overflow: hidden;
      p {
        font-size: 1.0625rem;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.21875rem;
        img {
          margin-left: 0.75rem;
          width: 1.6875rem;
          height: 1.6875rem;
          background: rgba(242, 242, 242, 1);
          border-radius: 0.84375rem;
        }
      }
    }
  }
}
.audit {
  // width: 100%;
  // height: 100%;
  // position: absolute;
  padding: 6.0625rem 4.1875rem 0 4.1875rem;

  .audit-div {
    // width: 15.09375rem;
    // height: 10.65625rem;
    width: 100%;
    height: 10.65625rem;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate (-50%, -50%);
    // width: 100px;
    // height: 100px;
    // background: red;
    position: absolute;
    top: -9.0625rem;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    text-align: center;

    img {
      width: 7.84375rem;
      height: 7.15625rem;
    }
    p {
      padding-top: 1.875rem;
      font-size: 1rem;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
  .audit-audit {
    // width: 15.09375rem;
    // height: 10.65625rem;
    width: 100%;
    height: 10.65625rem;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate (-50%, -50%);
    // width: 100px;
    // height: 100px;
    // background: red;
    position: absolute;
    top: -12.0625rem;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    text-align: center;

    img {
      width: 9.28125rem;
      height: 6.75rem;
    }
    p {
      padding-top: 1.875rem;
      font-size: 1rem;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    p:last-child {
      color: rgba(153, 153, 153, 1);
    }
  }
}
</style>
